// Central config for the "Plans" mega-menu + the 4 plan landing pages.
export const PLAN_LINKS = [
  {
    id: "subscription",
    to: "/plans/subscription",
    label: "Subscription — Self-Serve",
    tagline: "DIY predictor, cutoffs & college data",
    icon: "Rocket",
    accent: "#10B981", // mint
  },
  {
    id: "priority",
    to: "/plans/priority-counselling",
    label: "Priority Counselling",
    tagline: "Expert, done-for-you admission support",
    icon: "Crown",
    accent: "#6043EF", // violet
  },
  {
    id: "nri",
    to: "/plans/nri-counselling",
    label: "NRI Counselling",
    tagline: "NRI & management-quota specialists",
    icon: "GlobeHemisphereEast",
    accent: "#F59E0B", // amber
  },
  {
    id: "affiliate",
    to: "/plans/affiliate",
    label: "B2B — Affiliate Program",
    tagline: "Partner with us & earn per admission",
    icon: "Handshake",
    accent: "#EC4899", // pink
  },
];
